import { Component, OnDestroy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { LayoutService } from './service/app.layout.service';
import { environment } from 'environment';

@Component({
    selector: 'app-layout',
    templateUrl: './app.layout.component.html',
})
export class AppLayoutComponent implements OnDestroy {
    debug: boolean = environment.debug || false;
    isFascicleEdit: boolean = false;
    isNavigating: boolean = false;
    breadcrumbs: any[] = [];
    currentYear: number = new Date().getFullYear();

    private routerSub: Subscription;

    constructor(
        public layoutService: LayoutService,
        public router: Router,
        private location: Location,
    ) {
        this.routerSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.isNavigating = true;
            } else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                this.isNavigating = false;
                if (event instanceof NavigationEnd) {
                    this.isFascicleEdit = event.url.includes('catalog') && event.url.includes('fascicle/');
                    this.updateBreadcrumbs();
                }
            }
        });
    }

    get containerClass() {
        return {
            'layout-light': this.layoutService.config().colorScheme === 'light',
            'layout-dim': this.layoutService.config().colorScheme === 'dim',
            'layout-dark': this.layoutService.config().colorScheme === 'dark',
            'p-input-filled': this.layoutService.config().inputStyle === 'filled',
            'p-ripple-disabled': !this.layoutService.config().ripple,
            'layout-fascicle-edit': this.isFascicleEdit,
        };
    }

    private updateBreadcrumbs(): void {
        let currentRoute = this.router.routerState.snapshot.root;
        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
        }
        this.breadcrumbs = currentRoute.data['breadcrumbs'] || [];
    }

    goBack(): void {
        this.location.back();
    }

    ngOnDestroy() {
        this.routerSub.unsubscribe();
    }
}
